var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.data),expression:"data"}],staticClass:"cursor-pointer",attrs:{"src":require("@/assets/images/help.png"),"alt":"help"},on:{"click":_vm.onclick}})}
var staticRenderFns = []

export { render, staticRenderFns }